import { mutatorAction } from 'satcheljs';
import getAccountBySourceId from '../selectors/getAccountBySourceId';
import tryGetGlobalSettingsAccountMailboxInfo from '../selectors/tryGetGlobalSettingsAccountMailboxInfo';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { logStartUsage } from 'owa-analytics-start';

/**
 * Update the accountDescription of the specified Coprincipal account source in the store
 */
const updateCoprincipalAccountDescriptionMutator: (
    sourceId: string,
    accountDescription: string
) => void = mutatorAction(
    'UPDATE_COPRINCIPAL_ACCOUNT_DESCRIPTION',
    function (sourceId: string, accountDescription: string): void {
        if (!getAccountBySourceId(sourceId)) {
            // Account not found; the store may not be fully initialized during early boot
            logStartUsage(
                'AccountDescription_UpdateCoprincipalSourceIdNotFound',
                tryGetGlobalSettingsAccountMailboxInfo(false)
            );
            return;
        }
        const store = getAccountSourceListStore();
        for (const source of store.sources) {
            if (source.sourceId === sourceId) {
                source.accountDescription = accountDescription;
            }
        }
    }
);
export default updateCoprincipalAccountDescriptionMutator;
